import { SelectedManualAction, ServiceProposalManualAction } from "@repo/common"
import {
  addManualAction,
  removeManualAction,
  updateManualActionProductDecision,
  updateManualActionWithSelectedProducts,
} from "@repo/ui/lib/product-choice-utils"
import { useFieldContext } from "../hooks/form-contexts"
import { ServiceProposalManualActionCard } from "./service-proposal-manual-action-card"

export interface ServiceProposalManualActionsFieldProps {
  availableActions: ServiceProposalManualAction[]
  showProductComments?: boolean
}

export const ServiceProposalManualActionsField = ({
  availableActions,
  showProductComments = true,
}: ServiceProposalManualActionsFieldProps) => {
  const field = useFieldContext<SelectedManualAction[]>()

  return (
    <div className="space-y-4">
      {availableActions.map((manualActionData) => {
        const selectedAction = field.state.value.find(
          (sma) => sma.id === manualActionData.id,
        )
        const isSelected = !!selectedAction

        const updatedManualActionData =
          updateManualActionWithSelectedProducts(manualActionData)

        const handleSelect = () => {
          // Mandatory actions are locked — the customer cannot toggle them.
          if (manualActionData.isMandatory) return
          field.handleChange(
            isSelected
              ? removeManualAction(field.state.value, manualActionData.id)
              : addManualAction(
                  field.state.value,
                  manualActionData.id,
                  manualActionData.productChoices,
                ),
          )
        }

        const handleProductSelect =
          manualActionData.productChoices.length > 0 && selectedAction
            ? (productId: string, choiceId: string) => {
                field.handleChange(
                  updateManualActionProductDecision(
                    field.state.value,
                    manualActionData.id,
                    choiceId,
                    productId,
                  ),
                )
              }
            : undefined

        return (
          <ServiceProposalManualActionCard
            key={manualActionData.id}
            data={updatedManualActionData}
            selected={isSelected}
            onSelect={handleSelect}
            onProductSelect={handleProductSelect}
            productDecisions={selectedAction?.productDecisions}
            showProductComments={showProductComments}
          />
        )
      })}
    </div>
  )
}
